import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import clientService from "../services/clientService";
import entrepotservice from "../services/entrepotService";
import transporteurService from "../services/transporteurService";

const initialState = {
    transporteurs: [],
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 5, // Size of each page
    isAdded: false, // Flag to indicate if a new client has been added

};

const transporteurSlice = createModule({
    name: 'transporteurs',
    initialState,
    reducers: {
        list: (state) => {
            state.loading = true;
        },
        addTransporteur: (state) => {
            state.loading = true;
        },
        updateTransporteur: (state) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.transporteurs = payload;
            // state.totalElements = payload.body.totalElements; // Assuming totalElements is in payload
            // state.totalPages = payload.body.totalPages; // Assuming totalPages is in payload
            // state.pageNumber = payload.body.pageNumber;
        },
        finishFetching: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action || "An error occurred";
        },
        
    },
    sagas: (A) => ({
        *[A.list]() {
            try {
                const {data}  = yield call(transporteurService.list);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.addTransporteur]({ payload }) {
            try {
                const {data} = yield call(transporteurService.addTransporteur, payload.data);
                yield put(A.finishFetching());
                yield put(A.list());
                yield call(payload.onSuccess(data.body));
            } catch (e) {
                console.log(e);
                yield put(A.fetchError());
            }
        },
        *[A.updateTransporteur]({ payload }) {
            try {
                const { data } = yield call(transporteurService.update, payload.id, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
    }),
});

export default transporteurSlice;
export const transporteurActions = transporteurSlice.actions;